export const getOptions = (count: number) =>
  Array(count)
    .fill(null)
    .map((_, index) => index + 1);
